import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  MapPin,
  Clock3,
  Mail,
  PhoneCall,
  ChevronDown,
  Menu,
  X,
  ShieldCheck,
  Sparkles,
  Home,
  Building2,
  Users,
  BriefcaseBusiness,
  Calculator,
  PiggyBank,
  MessageCircle,
} from "lucide-react";

import logo from "../assets/img/gmt_logo_icon.svg";
import "../assets/css/header.css";

export default function WebsiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [navScrolled, setNavScrolled] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setNavScrolled(window.scrollY > 20);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) closeMenu();
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="top-bar">
        <div className="top-bar-inner">
          <div className="top-left">
            <span>
              <MapPin size={14} />
              2nd Floor, Wing A, Plot No. 114, Yakubu Gowon Way, Asokoro, Abuja
            </span>

            <span>
              <Clock3 size={14} />
              9:00 am – 5:00 pm
            </span>
          </div>

          <div className="top-right">
            <span>
              <Mail size={14} />
              gmttechnologieslimited@gmail.com
            </span>

            <span>
              <PhoneCall size={14} />
              08126476896
            </span>
          </div>
        </div>
      </div>

      <header className={`header-wrapper ${navScrolled ? "nav-scrolled" : ""}`}>
        <div className="nav-bar">
          <div className="nav-inner">
            <NavLink to="/" className="brand" onClick={closeMenu}>
              <span className="brand-logo-wrap">
                <img
                  src={logo}
                  alt="GMT Technologies Limited Logo"
                  className="brand-logo"
                />
              </span>

              <span className="brand-copy">
                <span className="brand-text">GMT TECHNOLOGIES LIMITED</span>
                <span className="brand-subtitle">
                  <ShieldCheck size={12} />
                  Digital finance partner
                </span>
              </span>
            </NavLink>

            <button
              type="button"
              className={`menu-toggle ${menuOpen ? "active" : ""}`}
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
            >
              {menuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>

            <div className={`nav-content ${menuOpen ? "open" : ""}`}>
              <nav className="nav-links">
                <NavLink to="/" end onClick={closeMenu}>
                  <Home size={16} />
                  Home
                </NavLink>

                <div className="nav-dropdown">
                  <button type="button" className="nav-link">
                    <Building2 size={16} />
                    About
                    <ChevronDown size={14} className="dropdown-arrow" />
                  </button>

                  <div className="nav-dropdown-menu">
                    <NavLink to="/about" onClick={closeMenu}>
                      <Building2 size={15} />
                      Company Profile
                    </NavLink>

                    <NavLink to="/management-team" onClick={closeMenu}>
                      <Users size={15} />
                      Management Team
                    </NavLink>
                  </div>
                </div>

                <NavLink to="/services" onClick={closeMenu}>
                  <BriefcaseBusiness size={16} />
                  Services
                </NavLink>

                <NavLink to="/loan-calculator" onClick={closeMenu}>
                  <Calculator size={16} />
                  Loan Calculator
                </NavLink>

                <NavLink to="/investment" onClick={closeMenu}>
                  <PiggyBank size={16} />
                  Lenders Plans
                </NavLink>

                <NavLink to="/contact" onClick={closeMenu}>
                  <MessageCircle size={16} />
                  Contact
                </NavLink>
              </nav>

              <div className="header-actions">
                <div className="social-icons">
                  <a href="#" aria-label="Facebook">
                    <span className="social-letter">f</span>
                  </a>

                  <a href="#" aria-label="X">
                    <span className="x-icon">𝕏</span>
                  </a>

                  <a href="#" aria-label="LinkedIn">
                    <span className="social-letter">in</span>
                  </a>
                </div>

                <NavLink
                  to="/applyloan"
                  className="header-cta"
                  onClick={closeMenu}
                >
                  <Sparkles size={15} />
                  Apply Now
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}